import React, { useState, useEffect } from "react";

// Components
import { Dropdown } from 'react-bulma-components';
import { ChevronDown } from 'react-feather';

// actions
import { makeAPIRequest } from "shared/state/fetch";

// Styles
import styles from './CurrencySelector.module.scss';

const CurrencySelector = ({ currency=false, onSelect, withName=false }) => {
    const [currencies, setCurrencies] = useState([]);
    const [selected, setSelected] = useState(currency);

    const handleOnChange = (ev) => {
        setSelected(ev);
        const currencyObj = currencies.filter(item => item.code === ev);
        onSelect(Object.assign(...currencyObj));
    }

    const perPage=110;

    useEffect(() => {
        makeAPIRequest(`currencies?perPage=${perPage}`)
            .then(response => {
                setCurrencies(response.result.data);
                //response.status && handleTokenStatus(response);
            }
        )
    }, []);

    return (
        <>
        { currencies && currencies.length > 0 &&
            <Dropdown
                className={ styles.dropdown }
                icon={<ChevronDown size={ 15 } strokeWidth={2} />}
                onChange={ handleOnChange }
                value={ selected || 'EUR' }
                label="">
                { currencies.map((currency, index) => {
                    return <Dropdown.Item
                        active={ selected === currency.code }
                        key={ index }
                        renderAs="a"
                        value={ currency.code }>
                          { withName ? `${currency.name} (${currency.code})` : currency.code }
                    </Dropdown.Item>
                    })
                }
            </Dropdown>
        }</>
    )
}

export default CurrencySelector;
